import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, getOrganizationBySlug } from 'wasp/client/operations';
import { useAuth } from 'wasp/client/auth';
import { DashboardLayout } from '../../../client/components/Sidebar';
import { InformationDeskContent } from '../../information-desk/InformationDeskPage';
import { OrgHubOverview } from '../../hub-overview/OrgHubOverview';
export default function OrgInformationDeskPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data: user } = useAuth();

  const { data: org } = useQuery(
    getOrganizationBySlug,
    { slug: slug! },
    { enabled: !!slug }
  ) as { data: any };

  const locationId: string = org?.locationOrganizations?.[0]?.location?.id ?? '';

  const isAdmin = !!user && (
    user.platformRole === 'ADMINISTRATOR' ||
    user.platformRole === 'PLATFORM_OWNER' ||
    user.platformRole === 'MODERATOR'
  );

  return (
    <DashboardLayout>
      <div className="w-full px-4 sm:px-6 py-6">
        {slug && (
          <OrgHubOverview slug={slug} locationId={locationId}>
            {locationId && (
              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">Information Desk</h2>
                <InformationDeskContent
                  locationId={locationId}
                  isAdmin={isAdmin}
                  orgSlug={slug}
                  orgName={org?.name}
                  showTodayEvents={false}
                />
              </section>
            )}
          </OrgHubOverview>
        )}
      </div>
    </DashboardLayout>
  );
}
